<template>
  <div
    class="flex h-full flex-col lg:flex-row"
    :class="[isPage ? 'items-center justify-center' : '']"
  >
    <div
      class="layout-height hidden w-full bg-grey-50 bg-cover bg-center lg:block"
      :class="[
        isPage
          ? 'h-[clamp(350px,100%,50vh)] lg:w-[44%] 2xl:w-[45%]'
          : '!h-[200px] lg:!h-[470px] lg:w-[186px]',
      ]"
    >
      <ImageCommon
        :src="image"
        alt="login"
        :class="classesImage"
        loading="eager"
        fetchpriority="high"
      />
    </div>
    <div :class="classesContainer">
      <slot />
    </div>
  </div>
</template>

<script setup lang="ts">
/** components */
import ImageCommon from '~/src/components/common/images/ImageCommon.vue'
import { twMerge } from 'tailwind-merge'

const props = withDefaults(
  defineProps<{
    image: string
    isPage?: boolean
    isResetPassword?: boolean
  }>(),
  {
    isPage: false,
    isResetPassword: false,
  },
)

const classesImage = ref(
  twMerge(
    'w-full object-cover',
    props.isPage ? 'h-[400px] lg:h-full' : 'h-[200px] lg:h-[470px]',
  ),
)

const classesContainer = ref(
  twMerge(
    'flex flex-col items-center justify-center',
    props.isResetPassword ? 'h-[min(850px,95vh)] lg:h-[max(900px,90vh)]' : '',
    props.isPage
      ? 'w-full h-full lg:w-[56%] 2xl:w-[55%] px-0 my-10 lg:my-0'
      : 'w-full lg:w-[426px] pb-5 px-5 lg:mb-0 lg:pl-10 lg:pr-16',
  ),
)
</script>

<style scoped>
/* stylelint-disable media-query-no-invalid */
@media screen(lg) {
  .layout-height {
    height: max(900px, 100vh); /* Firefox fallback */
    height: max(900px, 100dvh);
  }
}
</style>
